import { cn } from "../../../utils";

type OwnImageProps = React.HTMLProps<HTMLImageElement> & {
  alt: string;
};

const OwnImage = (props: OwnImageProps) => {
  const { className, alt, ...rest } = props;

  return (
    <img
      {...rest}
      className={cn(
        "absolute inset-0 h-full w-full object-cover text-transparent",
        className
      )}
      alt={alt}
    />
  );
};

export default OwnImage;
